var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "justify-content-center justify-content-sm-between" },
    [
      _c(
        "b-col",
        {
          staticClass: "order-sm-1 order-2 mt-3 mt-sm-0",
          attrs: { cols: "auto" },
        },
        [
          _vm.displayPrevious
            ? _c(
                "b-button",
                {
                  staticClass: "skip-disable-all-inputs",
                  attrs: {
                    variant: "white",
                    disabled: !_vm.canGoBack || _vm.saving,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("back", $event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.actions.previousStep")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "order-sm-2 order-1", attrs: { cols: "auto" } },
        [
          _vm.saving
            ? _c("b-button", { attrs: { variant: "primary", disabled: "" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.words.saving")) +
                    "...\n    "
                ),
              ])
            : _vm.displayNext
            ? _c(
                "b-button",
                {
                  staticClass: "skip-disable-all-inputs",
                  attrs: {
                    variant: "primary",
                    disabled: _vm.disableSaveButton && _vm.isSubmitPage,
                  },
                  on: { click: _vm.handleClick },
                },
                [_vm._v("\n      " + _vm._s(_vm.saveText) + "\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }